
import React from 'react'
import Chart from 'react-apexcharts'
import { COLORS } from './chart.constant'
import jwt_decode from 'jwt-decode';

const BasicColumn = () => {
    const data = [
        {
            name: (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : 'Orlando' ),
            data: [3600, 2700, 2800, 2500, 3600, 3580, 3300, 3640, 3800],
        },
    ]

    return (
        <Chart
            options={{
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                    },
                },
                colors: COLORS,
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent'],
                },
                xaxis: {
                    categories: [
                        'Dec',
                        'Jan',
                        'Feb',
                        'Mar',
                        'Apr',
                        'May',
                        'Jun',
                        'Jul',
                        'Aug',
                    ],
                },
                fill: {
                    opacity: 1,
                },
                tooltip: {
                    y: {
                        formatter: (val) => `$${val}.00`,
                    },
                },
            }}
            series={data}
            height={300}
            width={500}
            type="bar"
        />
    )
}

export default BasicColumn

